import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
export function NewOffers() {
  return <Section id="ofertas" className="bg-cream-warm py-20 scroll-mt-16" data-id="element-178">
      <div className="max-w-5xl mx-auto" data-id="element-179">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-forest-deep text-center mb-12" data-id="element-180">
          Elegí tu opción y empezá esta noche
        </h2>

        <div className="grid md:grid-cols-2 gap-8 items-stretch" data-id="element-181">
          {/* Oferta Básica */}
          <Card className="p-8 bg-white border-sage-mist flex flex-col" data-id="element-182">
            <h3 className="text-2xl font-bold text-forest-deep mb-4 text-center" data-id="element-183">
              Hogar Natural
            </h3>
            <div className="text-4xl font-bold text-forest-deep text-center mb-8" data-id="element-184">
              $19.999{' '}
              <span className="text-xl font-normal text-forest/70" data-id="element-185">ARS</span>
            </div>

            <ul className="space-y-4 mb-10 flex-grow" data-id="element-186">
              <li className="flex items-start gap-3" data-id="element-187">
                <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-188" />
                <span className="text-forest-deep" data-id="element-189">
                  Los 5 tomos completos en formato digital
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-190">
                <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-191" />
                <span className="text-forest-deep" data-id="element-192">
                  Acceso inmediato desde cualquier dispositivo
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-193">
                <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-194" />
                <span className="text-forest-deep" data-id="element-195">
                  Tuyo para siempre sin vencimiento
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-196">
                <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-197" />
                <span className="text-forest-deep" data-id="element-198">
                  Garantía de devolución total
                </span>
              </li>
            </ul>

            <Button variant="secondary" size="lg" fullWidth href={CHECKOUT_URLS.hogarNatural} className="bg-forest-light hover:bg-forest text-white" data-id="element-199">
              QUIERO ACCESO INMEDIATO — $19.999
            </Button>
          </Card>

          {/* Oferta Destacada */}
          <Card className="p-8 bg-white border-2 border-honey shadow-xl flex flex-col relative" data-id="element-200">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-honey text-forest-deep px-6 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider shadow-md" data-id="element-201">
              MÁS POPULAR
            </div>

            <h3 className="text-2xl font-bold text-forest-deep mb-4 text-center mt-2" data-id="element-202">
              Tu Super Pack de Hogar Natural en Casa
            </h3>
            <div className="text-4xl font-bold text-forest-deep text-center mb-8" data-id="element-203">
              $19.999{' '}
              <span className="text-xl font-normal text-forest/70" data-id="element-204">ARS</span>
            </div>

            <ul className="space-y-4 mb-10 flex-grow" data-id="element-205">
              <li className="flex items-start gap-3" data-id="element-206">
                <Check className="w-5 h-5 text-honey-dark shrink-0 mt-0.5" data-id="element-207" />
                <span className="text-forest-deep font-medium" data-id="element-208">
                  Los 5 tomos completos en formato digital
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-209">
                <Check className="w-5 h-5 text-honey-dark shrink-0 mt-0.5" data-id="element-210" />
                <span className="text-forest-deep font-medium" data-id="element-211">
                  Los 5 bonos con valor total de $20.995 ARS
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-212">
                <Check className="w-5 h-5 text-honey-dark shrink-0 mt-0.5" data-id="element-213" />
                <span className="text-forest-deep font-medium" data-id="element-214">
                  Acceso inmediato desde cualquier dispositivo
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-215">
                <Check className="w-5 h-5 text-honey-dark shrink-0 mt-0.5" data-id="element-216" />
                <span className="text-forest-deep font-medium" data-id="element-217">
                  Tuyo para siempre sin vencimiento
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-218">
                <Check className="w-5 h-5 text-honey-dark shrink-0 mt-0.5" data-id="element-219" />
                <span className="text-forest-deep font-medium" data-id="element-220">
                  Garantía de devolución total
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-221">
                <Check className="w-5 h-5 text-honey-dark shrink-0 mt-0.5" data-id="element-222" />
                <span className="text-forest-deep font-medium" data-id="element-223">
                  La colección completa para cuidar a toda tu familia
                </span>
              </li>
            </ul>

            <Button variant="primary" size="lg" fullWidth href={CHECKOUT_URLS.superPack} className="bg-forest-deep hover:bg-forest text-white font-bold text-lg py-4" data-id="element-224">
              QUIERO EL SISTEMA COMPLETO — $19.999
            </Button>
          </Card>
        </div>
      </div>
    </Section>;
}